import line from "../assets/Line 1.png"
const Line = () => {
  return (
    <img src={line} alt="" />
  )
}

export default  Line